module.exports = __webpack_public_path__ + "img/joinDialog-btn.ff597d11.png";